import useHovered, { SharedHoveredProps } from '../hooks/useHovered';
import { IndexableObject } from '../utils/types/ObjectTypes';
import type { JSX } from 'react';

export interface HoverProviderProps
  extends SharedHoveredProps,
    IndexableObject {
  children: ({
    hovered,
    onMouseEnter,
    onMouseLeave,
    onMouseMove,
  }: SharedHoveredProps) => JSX.Element;
}

const HoverProvider = (props: HoverProviderProps) => {
  return props.children(useHovered(props));
};

HoverProvider.displayName = 'HoverProvider';

export default HoverProvider;
